// icons/motorbike.svg
export const MotorbikeIconV2 = (props) => (
  <svg
    className={props.className}
    width="42"
    height="30"
    viewBox="0 0 42 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.1626 26.3736C33.0049 26.3736 31.2557 24.6243 31.2557 22.4666C31.2557 20.3089 33.0049 18.5596 35.1626 18.5596C37.3204 18.5596 39.0696 20.3089 39.0696 22.4666C39.0696 24.6243 37.3204 26.3736 35.1626 26.3736ZM35.1626 29.3038C31.3866 29.3038 28.3254 26.2427 28.3254 22.4666C28.3254 18.6905 31.3866 15.6294 35.1626 15.6294C38.9387 15.6294 41.9999 18.6905 41.9999 22.4666C41.9999 26.2427 38.9387 29.3038 35.1626 29.3038Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.83721 26.3736C4.67944 26.3736 2.93023 24.6243 2.93023 22.4666C2.93023 20.3089 4.67944 18.5596 6.83721 18.5596C8.99494 18.5596 10.7442 20.3089 10.7442 22.4666C10.7442 24.6243 8.99494 26.3736 6.83721 26.3736ZM6.83721 29.3038C3.06113 29.3038 0 26.2427 0 22.4666C0 18.6905 3.06113 15.6294 6.83721 15.6294C10.6133 15.6294 13.6744 18.6905 13.6744 22.4666C13.6744 26.2427 10.6133 29.3038 6.83721 29.3038Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.535 22.4648C19.535 21.9253 19.0977 21.488 18.5583 21.488H6.83734C6.29789 21.488 5.8606 21.9253 5.8606 22.4648C5.8606 23.0042 6.29789 23.4415 6.83734 23.4415H18.5583C19.0977 23.4415 19.535 23.0042 19.535 22.4648Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.2491 3.90723C30.5231 3.90723 30.0508 4.67133 30.3755 5.32077L32.329 9.22775C32.4944 9.55867 32.8327 9.76769 33.2026 9.76769H37.0267C37.8256 9.76769 38.2866 8.86098 37.8159 8.21545L34.9672 4.30847C34.7833 4.05638 34.49 3.90723 34.178 3.90723H31.2491ZM25.1731 15.074C25.0105 15.4127 24.6681 15.6282 24.2924 15.6282H18.3735C18.0332 15.6282 17.7175 15.4511 17.54 15.1608L14.1804 9.66465C13.8716 9.15938 14.0798 8.49773 14.6224 8.26038L16.9335 7.24925C17.7399 6.97655 18.5855 6.83746 19.4368 6.83746H23.8243C24.1894 6.83746 24.5241 7.04111 24.6918 7.36549L26.6369 11.1256C26.7778 11.398 26.7825 11.7206 26.6499 11.997L25.1731 15.074ZM2.93036 8.79095C2.39092 8.79095 1.95361 9.22824 1.95361 9.76769V11.343C1.95361 11.8374 2.32308 12.2539 2.81398 12.3128L12.3891 13.4618C13.1558 13.5538 13.721 12.7616 13.3845 12.0665L12.0659 9.34212C11.9028 9.00505 11.5613 8.79095 11.1868 8.79095H2.93036ZM24.4187 19.5351C24.4187 18.4562 23.5442 17.5816 22.4652 17.5816H18.5583C17.4794 17.5816 16.6048 18.4562 16.6048 19.5351V21.4886C16.6048 22.5675 17.4794 23.4421 18.5583 23.4421H22.4652C23.5442 23.4421 24.4187 22.5675 24.4187 21.4886V19.5351Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.2842 0.572567C26.1258 0.22387 25.778 0 25.3951 0H20.2671C19.7277 0 19.2904 0.437308 19.2904 0.976744C19.2904 1.5162 19.7277 1.95349 20.2671 1.95349H24.766L34.2733 22.8693C34.4965 23.3604 35.0756 23.5775 35.5667 23.3543C36.0577 23.1311 36.2749 22.552 36.0516 22.0609L26.2842 0.572567Z"
      fill="#333333"
    />
  </svg>
);
